{
  "$source": "Copies-Cards-Scans Pricing.pdf p.1 (scanned; OCR'd). Uses the PRINTED totals. Handwritten edits on the sheet (250 -> $59/$79, 500 -> $69/$89, UV struck out) are not applied until NMS confirms them.",
  "id": "business-cards",
  "label": "Business Cards",
  "type": "tiered-table",
  "quantityLabel": "Quantity",
  "unitLabel": "card",
  "fixedQuantities": true,
  "aboveMax": "quote",
  "options": [
    { "id": "stock", "label": "Card stock", "choices": [{ "id": "130lb-premium", "label": "Premium 130 lb, full color" }] },
    { "id": "sides", "label": "Printed sides", "choices": [{ "id": "1", "label": "One side" }, { "id": "2", "label": "Both sides" }] }
  ],
  "tables": [
    {
      "when": { "stock": "130lb-premium", "sides": "1" },
      "breaks": [{ "qty": 250, "unit": 0.196, "total": 49 }, { "qty": 500, "unit": 0.118, "total": 59 }, { "qty": 1000, "unit": 0.099, "total": 99 }],
      "source": "Copies-Cards-Scans Pricing.pdf p.1: Business cards, 1-sided"
    },
    {
      "when": { "stock": "130lb-premium", "sides": "2" },
      "breaks": [{ "qty": 250, "unit": 0.276, "total": 69 }, { "qty": 500, "unit": 0.158, "total": 79 }, { "qty": 1000, "unit": 0.119, "total": 119 }],
      "source": "Copies-Cards-Scans Pricing.pdf p.1: Business cards, 2-sided"
    }
  ]
}
